import React, { useEffect, useState } from 'react';
import './Home.css';
import Businessman from '../Businessman/Businessman'
import Cart from '../Cart/Cart';


const Home = () => {

    const [billionaires, setBillionaires] = useState([]);

    useEffect(() => {
        fetch("./billionaire.JSON")
            .then(res => res.json())
            .then(data => setBillionaires(data))
    }, [])


    const [cart, setCart] = useState([]);

    // add eventHandlerIn addToCart Button in UI...
    const handleAddToCart = (billionaire) => {
        const newCart = [...cart, billionaire];
        setCart(newCart);
    }
    
    return (
        <div className='background-img'>
            <div className='container mt-3 py-2 bg-secondary myStyle'>
                <h3>Hire!! Some billionaire for gather awesome business Idea.</h3>
                <q style={{color: 'white'}}>Success is not final; failure is not fatal: it is the courage to continue that counts.</q>
                <p style={{ color: 'yellow'}}>-Winston Chuchill</p>
                <h2>Top <span className='text-warning'>{billionaires.length}</span> Billionaire's list.</h2>
            </div>

            <div className="row">
                <div className="col-md-9">
                    <div className="row row-cols-1 row-cols-md-3 g-4 mt-4 mx-4">
                        {
                            billionaires.map(billionaire => <Businessman
                                key={billionaire.rank}
                                // product R handleAddToCart(function) k pathabo...
                                billionaire={billionaire}
                                handleAddToCart = {handleAddToCart}>
                            </Businessman>)
                        }
                    </div>
                </div>

                <div className="col-md-3">
                    {
                        <Cart
                            cart={cart}>
                        </Cart>
                    }
                </div>
            </div>
        </div>
    );
};

export default Home;